var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container\n            page-container\n            is-flex\n            is-flex-wrap-wrap\n            is-justify-content-space-evenly\n            is-align-items-center"},[_c('MarketingList'),_c('SignUpForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }